export default __webpack_public_path__ + "92eeb684fe5f711de9791145542e557e.png";